import { render, staticRenderFns } from "./ScannedSOItems.vue?vue&type=template&id=bedb4850"
import script from "./ScannedSOItems.vue?vue&type=script&lang=js"
export * from "./ScannedSOItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports